import { useTranslation } from "react-i18next";

export default function VoicesSection() {
  const { t } = useTranslation();

  const voices = [
    { text: t("voice1"), icon: "ri-parent-line" },
    { text: t("voice2"), icon: "ri-heart-line" },
    { text: t("voice3"), icon: "ri-user-smile-line" },
    { text: t("voice4"), icon: "ri-flight-takeoff-line" },
    { text: t("voice5"), icon: "ri-star-line" },
    { text: t("voice6"), icon: "ri-book-open-line" }
  ];

  return (
    <section id="voices" className="py-24 bg-gradient-to-b from-teal-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-bold text-center text-gray-900 mb-16">
          {t("voices_title")}
        </h2>

        <div className="grid md:grid-cols-2 gap-8">
          {voices.map((voice, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                  <i className={`${voice.icon} text-2xl text-teal-600`}></i>
                </div>
                <p className="text-gray-700 leading-relaxed text-justify flex-1">
                  {voice.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
